import React from 'react';
import isMobile from 'ismobilejs';
import { connect } from 'react-redux';
import { movil } from '../app-movil';
import { guardarDatosInconvenientes } from './service.act';
import { callService, goTo } from '../tools';

import InconvenientesForm from './inconvenientes.frm.js';

const mapState = (state) => {
	return {
		loading: state.global.loading,
		sistema: state.registro.configuracion.sistema
	};
};

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({"type": "LOADER", "show": show});
		},
		alerta: (sTitulo, sMensaje) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": sTitulo, "mensaje": sMensaje });
		},
		registrarDatos(sTipo, sExtension, sLada, sTelefono) {
			dispatch(guardarDatosInconvenientes(sTipo, sExtension, sLada, sTelefono));
		},
		pasoCompleto: () => {
			dispatch({ "type": "REGISTRO_COMPLETO", completo: true });
		}
	};
};

class Inconvenientes extends React.Component {

	getHerramienta = () => {
		return (isMobile.any == true)? "APP" : "PORTAL";
	}

	submit = (data) => {
		let $this = this;
		let herramienta = this.getHerramienta();
		
		$this.props.loader(true);
		$this.props.registrarDatos(data.tipo, data.extension, data.lada, data.telefono);

		let llamaServicio = new callService({
			service: "registro.datosInconvenientes",
			secure: true,
			data: {
				tipoTelefono: data.tipo,
				extension: data.extension,
				lada: data.lada,
				telefono :data.telefono,
				llamar: data.llamar,
				sistema: this.props.sistema
			}
		}).execute().then((respuesta) => {
			console.log("Respuesta", respuesta);
			$this.props.loader(false);
			$this.props.pasoCompleto();
			
			let mensaje = {"return": "login"};
			movil("registroAsistido", mensaje);
			
			if(data.llamar && herramienta == "APP") {
				window.location.href = "tel://"+data.lada+data.telefono;
				setTimeout(() => { 
					goTo("login");
					//window.location.href = '/#!/login'; 
				}, 5000);
			} else {
				goTo("login");
				//window.location.href = '/#!/login';  
			}
		}).catch((error) => {
			console.log("Error", error);
			$this.props.loader(false);
			$this.props.alerta(error.message.codigoError, error.message.mensaje);
		});
	}

	render() {
		return <InconvenientesForm onSubmit={this.submit} />;
	}
}

export default connect(mapState, mapDispatch)(Inconvenientes);


// WEBPACK FOOTER //
// ./src/registro-asistido/inconvenientes.cmpt.js